import type { ComponentProps } from 'react';

import { clsxm } from '@vs-shop/utils';
import { type VariantProps, cva } from 'class-variance-authority';
import { PuffLoader } from 'react-spinners';

export const loaderVariants = cva('items-center justify-center', {
  variants: {
    layout: {
      block: 'grid min-h-full w-full',
      inline: 'inline-grid',
    },
  },
  defaultVariants: { layout: 'block' },
});

export type LoaderProps = ComponentProps<'div'> &
  VariantProps<typeof loaderVariants> & {
    size?: number;
    color?: string;
  };

export function Loader({
  size = 200,
  color = 'var(--color-primary)',
  layout,
  className,
  ...props
}: LoaderProps) {
  return (
    <div data-slot="loader" className={clsxm(loaderVariants({ layout }), className)} {...props}>
      <PuffLoader size={size} color={color} />
    </div>
  );
}
